module.exports = __webpack_public_path__ + "img/app-mockup.3bc04a48.gif";